/* Skali – cadeaux par palier
   - palier calculé sur le total APRÈS réductions (codes, remises), hors cadeaux et hors cartes cadeaux
   - cadeau retiré si le palier n'est plus atteint
   - cadeau limité à 1 exemplaire (pas de +, pas de doublon depuis la fiche produit)
   Remplace la logique cadeau d'origine de theme.js (neutralisée ci-dessous). */
(function(){
  if(!window.jQuery) return;
  var $ = window.jQuery;
  var TIERS = null, busy = false, fixes = 0, tried = {};

  function prepare(){
    var $p = $('#cartProgress');
    if(!$p.length) return false;
    if(TIERS) return true;
    try { TIERS = JSON.parse($p.attr('data-tiers') || '[]'); } catch(e){ TIERS = []; }
    // Neutralise la gestion cadeau d'origine du thème (elle ne voit plus de cadeaux)
    var stripped = $.map(TIERS, function(t){ var c = $.extend({}, t); c.gift = 0; return c; });
    $p.attr('data-tiers', JSON.stringify(stripped));
    return true;
  }
  function tiersSorted(){ return $.grep(TIERS || [], function(t){ return t.amount > 0; }).sort(function(a,b){ return a.amount - b.amount; }); }
  function giftMap(){ var m = {}; $.each(TIERS || [], function(i,t){ if(t.gift){ m[String(t.gift)] = t; } }); return m; }
  function vid(it){ return String(it.variant_id || it.id); }
  function isGift(it, m){ return !!(m[vid(it)] || (it.properties && it.properties._gift)); }
  // Propriétés de la ligne cadeau : _gift (cachée) + mention visible au paiement et sur la commande
  var GIFT_PROP = 'Cadeau';
  function giftText(t){ var x = Math.round(t.amount / 100); return 'offert dès ' + x + ' frs d\'achat, réductions déduites. Si un code fait passer ta commande sous ' + x + ' frs, le cadeau ne sera pas envoyé.'; }
  function giftProps(v, t){ var p = { _gift: v }; if(t){ p[GIFT_PROP] = giftText(t); } return p; }
  function linePrice(it){ return (it.final_line_price != null) ? it.final_line_price : (it.line_price || 0); }
  // Les cartes cadeaux ne comptent pas pour les paliers (bon envoyé par mail, rien à expédier)
  var GIFT_CARD_HANDLES = ['cartes-cadeaux'];
  function isGiftCard(it){ return !!(it && (it.gift_card || $.inArray(it.handle, GIFT_CARD_HANDLES) !== -1)); }
  function qualifying(cart, m){
    var q = (cart.total_price != null) ? cart.total_price : 0;
    if(cart.total_price == null){ $.each(cart.items, function(i,it){ if(!isGift(it,m) && !isGiftCard(it)) q += linePrice(it); }); }
    else { $.each(cart.items, function(i,it){ if(isGift(it,m) || isGiftCard(it)) q -= linePrice(it); }); }
    return Math.max(0, q);
  }
  function money(c){ try { return theme.Currency.formatMoney(c, theme.moneyFormat); } catch(e){ return (c/100).toFixed(2) + ' CHF'; } }
  function onCartPage(){ return /(^|\s)template-cart(\s|$)/.test(document.body.className); }

  function reloadCartPage(){
    if(!onCartPage()) return;
    var n = 0, now = Date.now();
    try { var g = JSON.parse(sessionStorage.getItem('skGiftReload') || '{}'); if(g.t && now - g.t < 60000){ n = g.n || 0; } } catch(e){}
    if(n >= 3) return;
    try { sessionStorage.setItem('skGiftReload', JSON.stringify({ t: now, n: n + 1 })); } catch(e){}
    window.location.reload();
  }
  function fix(key, qty, props){
    fixes++; busy = true;
    var t = setTimeout(function(){ busy = false; }, 5000);
    CartJS.updateItemById(key, qty, props || {}, {
      success: function(){ clearTimeout(t); busy = false; reloadCartPage(); },
      error: function(){ clearTimeout(t); busy = false; }
    });
  }

  // Contrôle des cadeaux. Retourne true si une correction est en cours.
  function giftLogic(cart){
    var $p = $('#cartProgress'), $box = $('#cartGiftUnlock');
    var m = giftMap(), q = qualifying(cart, m), lines = {};
    $.each(cart.items, function(i,it){ if(!isGift(it,m)) return; var v = vid(it); (lines[v] = lines[v] || []).push(it); });
    if(busy) return true;
    if(fixes < 10){
      for(var v in lines){
        if(!lines.hasOwnProperty(v)) continue;
        var ls = lines[v], t = m[v];
        if(!t || q < t.amount){ tried[v] = false; fix(ls[0].key, 0); return true; }      // palier non atteint
        if(ls.length > 1){ fix(ls[1].key, 0); return true; }                              // doublon
        var l = ls[0];
        var pr = l.properties || {};
        if(l.quantity !== 1 || !pr._gift || pr[GIFT_PROP] !== giftText(t)){ fix(l.key, 1, giftProps(v, t)); return true; } // quantité 1 + marquage + mention
      }
    }
    var auto = $p.attr('data-gift-auto') === 'true';
    var gifts = $.grep(tiersSorted(), function(t){ return t.gift; });
    if(auto){
      $box.empty().hide();
      for(var i = 0; i < gifts.length; i++){
        var g = gifts[i], gv = String(g.gift);
        if(q >= g.amount && !lines[gv] && !tried[gv]){
          tried[gv] = true; busy = true;
          var to = setTimeout(function(){ busy = false; }, 5000);
          CartJS.addItem(g.gift, 1, giftProps(gv, g), {
            success: function(){ clearTimeout(to); busy = false; reloadCartPage(); },
            error: function(){ clearTimeout(to); busy = false; }
          });
          return true;
        }
      }
    } else {
      var html = '';
      $.each(gifts, function(i,t){
        var gv = String(t.gift);
        if(q >= t.amount && !lines[gv]){
          html += '<div class="cartGift"><div class="cartGift__head"><i class="at ' + (t.icon || 'at-gift') + '"></i> ' + (t.label || 'Cadeau') + ' débloqué !</div>'
               +  '<div class="cartGift__row">' + (t.giftImg ? '<img class="cartGift__img" src="' + t.giftImg + '" alt="">' : '')
               +  '<div class="cartGift__info"><span class="cartGift__name">' + (t.giftTitle || '') + '</span><span class="cartGift__free">Offert</span></div>'
               +  '<button type="button" class="cartGift__add" data-id="' + gv + '">Ajouter le cadeau</button></div></div>';
        }
      });
      if(html){ $box.html(html).show(); } else { $box.empty().hide(); }
    }
    return false;
  }

  // Barre de progression et bandeau livraison, recalculés après réductions
  function renderBar(cart){
    var $p = $('#cartProgress'); if(!$p.length) return;
    var tiers = tiersSorted(), total = qualifying(cart, giftMap());
    var $fs = $('#cartFreeship');
    if(!tiers.length || !cart.item_count || total <= 0){ $p.hide(); $fs.hide(); return; }
    var max = tiers[tiers.length - 1].amount, $mk = $p.find('.cart-progress__markers');
    if($mk.children().length !== tiers.length){
      $mk.empty();
      $.each(tiers, function(i,t){ $mk.append('<span class="cart-progress__marker" style="left:' + Math.min(100, t.amount / max * 100) + '%"><i class="at ' + (t.icon || 'at-gift') + '"></i></span>'); });
    }
    $p.find('.cart-progress__fill').css('width', Math.min(100, total / max * 100) + '%');
    $mk.children().each(function(i){ $(this).toggleClass('reached', total >= tiers[i].amount); });
    var next = null;
    for(var j = 0; j < tiers.length; j++){ if(tiers[j].amount > total){ next = tiers[j]; break; } }
    var msg = next ? ($p.attr('data-msg') || '').replace('[reste]', money(next.amount - total)).replace('[recompense]', next.label || '') : ($p.attr('data-msg-done') || '');
    $p.find('.cart-progress__msg').html(msg);
    $p.show();
    var fsReached = false;
    $.each(tiers, function(i,t){ if(t.freeship && total >= t.amount){ fsReached = true; } });
    if(fsReached){ $fs.html($p.attr('data-freeship-msg') || '').show(); } else { $fs.hide(); }
  }

  // Page panier : pas de +/- sur les lignes cadeaux
  function cartPageGiftRows(){
    if(!onCartPage()) return;
    var m = giftMap();
    $('input[id^="updates_"]').each(function(){
      var key = this.id.replace('updates_', ''), v = key.split(':')[0];
      if(!m[v]) return;
      var $td = $(this).closest('td');
      $td.find('.qtyField').addClass('hide').hide();
      if(!$td.find('.giftTag').length){ $td.prepend('<span class="giftTag"><i class="at at-gift"></i> Cadeau</span>'); }
    });
  }

  function chf(c){ return Math.round(c / 100) + ' CHF'; }
  function esc(s){ return String(s).replace(/[&<>"']/g, function(ch){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[ch]; }); }

  // Styles du champ code promo et des mentions
  function injectStyles(){
    if(document.getElementById('skGiftStyles')) return;
    // Palette de la gamme barbe (ardoise) pour la barre, rouge vif pour le code promo
    var slate = '#6f8090', slateDark = '#26394b', slateLight = '#c4cfd7', slatePale = '#eef1f4', red = '#d32f2f';
    var css = ''
      /* Barre de progression + livraison offerte : couleurs discrètes */
      + 'body .cart-progress__track{background:' + slatePale + ' !important;}'
      + 'body .cart-progress__fill{background:' + slate + ' !important;}'
      + 'body .cart-progress__marker{border-color:' + slateLight + ' !important;}'
      + 'body .cart-progress__marker.reached{border-color:' + slate + ' !important;box-shadow:0 0 0 3px rgba(111,128,144,.15) !important;}'
      + 'body .cart-progress__marker.reached i{color:' + slate + ' !important;}'
      + 'body .cart-progress__msg b,body .cart-progress__msg .money{color:' + slateDark + ' !important;}'
      + 'body .cartFreeship{background:' + slatePale + ' !important;color:' + slateDark + ' !important;font-weight:600 !important;}'
      + 'body .giftTag{color:' + slate + ' !important;}'
      + '.skNote{font-size:11px;line-height:1.35;text-align:center;color:#8a8279;margin-top:8px;}'
      + '.skGiftNote{display:block;font-size:11px;line-height:1.3;color:#8a8279;margin-top:3px;text-transform:none;letter-spacing:0;font-weight:400;}'
      /* Code promo, juste au-dessus du total */
      + '.skPromo{list-style:none;display:block;margin:0 0 10px;}'
      + '.skPromo__hint{font-size:12px;line-height:1.35;color:' + red + ';font-weight:600;margin:0 0 6px;}'
      + '.skPromo__row{display:flex;gap:6px;}'
      + '.skPromo__input{flex:1;min-width:0;height:38px;padding:0 10px;border:1px solid ' + red + ';border-radius:4px;font-size:13px;text-transform:uppercase;background:#fff;}'
      + '.skPromo__input:focus{outline:none;box-shadow:0 0 0 2px rgba(211,47,47,.2);}'
      + '.skPromo__btn{flex:0 0 auto;height:38px;padding:0 14px;border:none;border-radius:4px;background:' + red + ';color:#fff;font-size:12px;font-weight:700;cursor:pointer;}'
      + '.skPromo__btn:hover{background:#b71c1c;}'
      + '.skPromo__btn[disabled]{opacity:.6;cursor:default;}'
      + '.skPromo__msg{font-size:12px;margin-top:6px;}'
      + '.skPromo__msg:empty{display:none;}'
      + '.skPromo__msg.err{color:' + red + ';}'
      + '.skPromo__codes{margin-top:6px;display:flex;flex-wrap:wrap;gap:6px;}'
      + '.skPromo__codes:empty{display:none;}'
      + '.skPromo__code{display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:700;padding:4px 8px;border-radius:4px;background:#fdecea;color:' + red + ';}'
      + '.skPromo__rm{border:none;background:none;padding:0;font-size:14px;line-height:1;cursor:pointer;color:' + red + ';}'
      /* « Vous aimerez aussi » : bandeau compact qui défile sur le côté */
      + 'body .cartReco{margin:4px 0 12px !important;}'
      + 'body .cartReco__title{margin:0 0 6px !important;}'
      + 'body .cartReco__list{flex-direction:row !important;gap:8px !important;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding-bottom:6px;scrollbar-width:thin;}'
      + 'body .cartReco__item{flex:0 0 112px !important;flex-direction:column !important;align-items:stretch !important;gap:4px !important;position:relative;scroll-snap-align:start;}'
      + 'body .cartReco__img img{width:112px !important;height:84px !important;}'
      + 'body .cartReco__name{font-size:11px !important;line-height:1.25 !important;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}'
      + 'body .cartReco__price{font-size:12px !important;}'
      + 'body .cartReco__add{position:absolute;top:4px;right:4px;width:26px !important;height:26px !important;font-size:16px !important;}'
      /* Accordéon quand le panier contient plus de 3 articles */
      + '#cartReco.skAcc .cartReco__title{cursor:pointer;display:flex;justify-content:space-between;align-items:center;padding:8px 0;border-top:1px solid #eee;border-bottom:1px solid #eee;margin:0 !important;user-select:none;}'
      + '#cartReco.skAcc .cartReco__title::after{content:"+";font-size:16px;line-height:1;color:#6f8090;}'
      + '#cartReco.skAcc:not(.skCollapsed) .cartReco__title{border-bottom:none;}'
      + '#cartReco.skAcc:not(.skCollapsed) .cartReco__title::after{content:"\\2013";}'
      + '#cartReco.skCollapsed .cartReco__list{display:none !important;}';
    $('<style id="skGiftStyles">' + css + '</style>').appendTo('head');
  }

  // Mentions : sous la barre, et sur chaque ligne cadeau du tiroir
  function renderNotes(){
    var $p = $('#cartProgress');
    if($p.length && !$p.find('.skNote').length){
      var de = /^de/i.test(document.documentElement.lang || '');
      $p.append('<div class="skNote">' + (de ? 'Geschenke und Gratisversand werden auf den Betrag nach Rabatten berechnet, ohne Geschenkkarten.' : 'Cadeaux et livraison offerte calculés sur le montant après réductions, hors cartes cadeaux.') + '</div>');
    }
  }

  // Champ code promo (tiroir + page panier)
  function promoHtml(){
    return '<div class="skPromo__hint">Un code promo ? Entre-le ici.</div>'
      + '<div class="skPromo__row"><input type="text" class="skPromo__input" placeholder="Code promo" autocomplete="off" autocapitalize="characters" spellcheck="false">'
      + '<button type="button" class="skPromo__btn">Appliquer</button></div>'
      + '<div class="skPromo__msg"></div><div class="skPromo__codes"></div>';
  }
  function placePromo(){
    // Ordre en bas du tiroir : code promo, livraison offerte, total
    var $tot = $('.cart_btns > li.cart_total').first(), $fs = $('.cart_btns > #cartFreeship').first();
    if($tot.length && !$tot.siblings('.skPromo').length){ $('<li class="skPromo">' + promoHtml() + '</li>').insertBefore($fs.length ? $fs : $tot); }
    if($fs.length && $tot.length && $fs.next()[0] !== $tot[0]){ $fs.insertBefore($tot); }
    if(onCartPage()){
      var $box = $('.cartSummery .bdr-box').first();
      if($box.length && !$box.find('.skPromo').length){ $('<div class="skPromo">' + promoHtml() + '</div>').insertBefore($box.find('.cart_total').first()); }
    }
  }
  function appliedCodes(cart){
    return $.grep(cart.discount_codes || [], function(d){ return d && d.code && d.applicable !== false; });
  }
  function renderPromo(cart){
    var codes = appliedCodes(cart), apps = cart.cart_level_discount_applications || [];
    var html = '';
    $.each(codes, function(i,d){
      var amt = 0;
      $.each(apps, function(j,a){ if(a.title && String(a.title).toUpperCase() === String(d.code).toUpperCase()){ amt += a.total_allocated_amount || 0; } });
      html += '<span class="skPromo__code">' + esc(d.code) + (amt ? ' : -' + money(amt) : '') + ' <button type="button" class="skPromo__rm" data-code="' + esc(d.code) + '" aria-label="Retirer le code">×</button></span>';
    });
    $('.skPromo__codes').html(html);
  }
  function setCodes(list, $scope, okMsg, tryCode){
    var $btn = $('.skPromo__btn').prop('disabled', true), $msg = $scope ? $scope.find('.skPromo__msg') : $('.skPromo__msg');
    $msg.removeClass('err').text('');
    $.ajax({ url: '/cart/update.js', type: 'POST', dataType: 'json', contentType: 'application/json', data: JSON.stringify({ discount: list.join(',') }) })
      .done(function(cart){
        var bad = false;
        if(tryCode){
          $.each(cart.discount_codes || [], function(i,d){ if(String(d.code).toUpperCase() === tryCode.toUpperCase() && d.applicable === false){ bad = true; } });
        }
        if(bad){
          // Code refusé : on le retire pour garder le panier propre
          var keep = $.map($.grep(cart.discount_codes || [], function(d){ return d.applicable !== false; }), function(d){ return d.code; });
          $.ajax({ url: '/cart/update.js', type: 'POST', dataType: 'json', contentType: 'application/json', data: JSON.stringify({ discount: keep.join(',') }) })
            .always(function(){ $btn.prop('disabled', false); $msg.addClass('err').text('Ce code n\'est pas valable pour ce panier.'); refreshCart(); });
          return;
        }
        $btn.prop('disabled', false);
        if(okMsg){ $msg.text(okMsg); }
        $('.skPromo__input').val('');
        refreshCart();
      })
      .fail(function(){ $btn.prop('disabled', false); $msg.addClass('err').text('Impossible d\'appliquer le code, réessaie.'); });
  }
  // Codes déjà dans le panier (lus sur /cart.js pour ne pas écraser un code de la newsletter)
  function currentCodes(cb){
    $.getJSON('/cart.js')
      .done(function(c){ cb($.map(appliedCodes(c || {}), function(d){ return d.code; })); })
      .fail(function(){ cb($.map(appliedCodes((window.CartJS && CartJS.cart) || {}), function(d){ return d.code; })); });
  }
  function refreshCart(){
    if(onCartPage()){ window.location.reload(); return; }
    if(window.CartJS && CartJS.getCart){ CartJS.getCart(); }
  }
  $(document).on('click', '.skPromo__btn', function(){
    var $scope = $(this).closest('.skPromo'), code = String($scope.find('.skPromo__input').val() || '').replace(/^\s+|\s+$/g, '');
    if(!code) return;
    currentCodes(function(list){
      if($.inArray(code.toUpperCase(), $.map(list, function(c){ return String(c).toUpperCase(); })) === -1){ list.push(code); }
      setCodes(list, $scope, 'Code appliqué.', code);
    });
  });
  $(document).on('keydown', '.skPromo__input', function(e){ if(e.key === 'Enter' || e.keyCode === 13){ e.preventDefault(); $(this).closest('.skPromo').find('.skPromo__btn').trigger('click'); } });
  $(document).on('click', '.skPromo__rm', function(){
    var rm = String($(this).data('code')).toUpperCase(), $scope = $(this).closest('.skPromo');
    currentCodes(function(list){
      setCodes($.grep(list, function(c){ return String(c).toUpperCase() !== rm; }), $scope, '', '');
    });
  });

  // « Vous aimerez aussi » : accordéon ouvert par défaut, replié automatiquement au-delà de 3 articles
  var recoChoice = null, recoWasBig = null;
  function recoAccordion(cart){
    var $r = $('#cartReco'); if(!$r.length) return;
    var m = giftMap(), n = 0;
    $.each(cart.items || [], function(i,it){ if(!isGift(it,m)) n += it.quantity; });
    var big = n > 3;
    if(recoWasBig !== null && big !== recoWasBig){ recoChoice = null; } // seuil franchi : on revient au comportement automatique
    recoWasBig = big;
    var collapsed = recoChoice ? (recoChoice === 'closed') : big;
    $r.addClass('skAcc').toggleClass('skCollapsed', collapsed);
  }
  $(document).on('click', '#cartReco.skAcc .cartReco__title', function(){
    var $r = $('#cartReco'), open = $r.hasClass('skCollapsed');
    recoChoice = open ? 'open' : 'closed';
    $r.toggleClass('skCollapsed', !open);
  });

  function run(){
    if(!window.CartJS || !CartJS.cart || !prepare()) return;
    var c = CartJS.cart;
    injectStyles();
    placePromo();
    renderBar(c);
    giftLogic(c);
    cartPageGiftRows();
    renderNotes();
    recoAccordion(c);
    if(c.discount_codes !== undefined){ renderPromo(c); }
    else { $.getJSON('/cart.js').done(renderPromo); }
  }

  prepare();
  $(document).on('cart.requestComplete', function(){ setTimeout(run, 0); });
  $(function(){ setTimeout(run, 1400); });
})();
